var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivityLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7794 13.2497H13.3091M5.7794 17.6735H13.3091M5.7794 9.18287H13.3091M18.1351 18.9167V7.31899C18.1351 6.89158 17.9631 6.48214 17.6578 6.18287L13.3091 1.91949C13.0117 1.62792 12.6118 1.4646 12.1953 1.4646H5.35066H2.29984C1.42117 1.4646 0.708862 2.1769 0.708862 3.05558V21.4236C0.708862 22.3023 1.42117 23.0146 2.29984 23.0146H16.5441C17.4227 23.0146 18.1351 22.3023 18.1351 21.4236V18.9167Z",
    stroke: "current",
    strokeWidth: 0.985714,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityLog);
export default __webpack_public_path__ + "static/media/activityLog.059833fd68a6d32b99c71857405a7903.svg";
export { ForwardRef as ReactComponent };